import React from "react";
import OperationsManagementEmployeeDetails from "./OperationsManagementEmployeeDetails";
import TerritoryAssignmentsCard from "./TerritoryAssignmentsCard";
import EmployeeTEAM from "../EmployeeTEAM";
import EmployeeComplaintCard from "../EmployeeComplaintCard";
import EmployeePto from "../EmployeePto";

interface OperationsManagementProfileProps {
  employeeId: number,
  employeeRoleId?: number, //needed if can view pto card
  internetUserId: number,
  canViewTeamCard?: boolean,
  canViewFeedbackCard?: boolean,
  canEditFeedbackCard?: boolean,
  canViewPtoCard?: boolean,
}

const OperationsManagementProfile = ({ employeeId, internetUserId, employeeRoleId, canViewTeamCard = false, canViewFeedbackCard = false, canEditFeedbackCard = false, canViewPtoCard = false }: OperationsManagementProfileProps) => {

  const isRenderingPtoCard = canViewPtoCard && employeeRoleId !== 0 && employeeRoleId !== undefined && employeeRoleId !== null;

  return (
    <div className="operations-management-profile-container padding-page-content">
      <OperationsManagementEmployeeDetails employeeId={employeeId} />
      <TerritoryAssignmentsCard employeeId={employeeId} />
      {canViewTeamCard &&
        <EmployeeTEAM
          internetUserId={internetUserId}
          overrideCellWidth={true}
        />}
      {canViewFeedbackCard &&
        <EmployeeComplaintCard
          employeeId={employeeId}
          cardTitleOverride="Employee Feedback"
          viewOnly={!canEditFeedbackCard}
        />}
      {isRenderingPtoCard &&
        <EmployeePto
          employeeId={employeeId}
          employeeRoleId={employeeRoleId}
          internetUserId={internetUserId}
        />}
    </div>
  );
};

export default OperationsManagementProfile;